const colors = {
    core: {
        white: "#ffffff",
        black: "#000000",
        deepBlue: {
            "1": "#faf8ff",
            "2": "#f0eef5",
            "3": "#e5e3ea",
            "4": "#d1cfd7",
            "5": "#b5b2bc",
            "6": "#908c99",
            "7": "#716e7c",
            "8": "#5a5469",
            "9": "#463f5f",
            "10": "#362f54",
            "11": "#2d264e",
            "12": "#221c46",
        },
        ultraGreen: {
            "1": "#dafcdb",
            "2": "#c7fcca",
            "3": "#85fd96",
            "4": "#00eb5e",
            "5": "#01d253",
            "6": "#01ad43",
            "7": "#008a34",
            "8": "#006825",
            "9": "#004f1a",
            "10": "#003d13",
            "11": "#00330e",
            "12": "#012f0d",
        },
        boldyBlue: {
            "1": "#e8f6fc",
            "2": "#def3fb",
            "3": "#c3ebfb",
            "4": "#88ddfb",
            "5": "#17ccf9",
            "6": "#0fa4c9",
            "7": "#0a83a1",
            "8": "#06637a",
            "9": "#034a5d",
            "10": "#043948",
            "11": "#06303c",
            "12": "#062c37",
        },
        veryYellow: {
            "1": "#fdf3d6",
            "2": "#fdeec1",
            "3": "#ffdc37",
            "4": "#f0cd01",
            "5": "#d2b301",
            "6": "#ad9400",
            "7": "#8a7501",
            "8": "#685800",
            "9": "#4f4200",
            "10": "#3d3300",
            "11": "#332a00",
            "12": "#2f2700",
        },
        blue: {
            "1": "#f3f3fc",
            "2": "#efeefb",
            "3": "#e3e2fa",
            "4": "#cfccfa",
            "5": "#b1b0fb",
            "6": "#878dfa",
            "7": "#526cf8",
            "8": "#1b51dc",
            "9": "#123ba7",
            "10": "#0f2d83",
            "11": "#0f266d",
            "12": "#0f2365",
        },
        darkGreen: {
            "1": "#d7fcea",
            "2": "#c3fce1",
            "3": "#78fcc7",
            "4": "#31ecae",
            "5": "#00cf96",
            "6": "#01ab7b",
            "7": "#008861",
            "8": "#006245",
            "9": "#004e36",
            "10": "#023c29",
            "11": "#043222",
            "12": "#042e20",
        },
        orange: {
            "1": "#fbf2ec",
            "2": "#faede3",
            "3": "#f9dfcd",
            "4": "#f8c5a0",
            "5": "#f8a05b",
            "6": "#d47420",
            "7": "#b26019",
            "8": "#874810",
            "9": "#67360b",
            "10": "#4f2a0a",
            "11": "#41230a",
            "12": "#3c210a",
        },
        confidentlyCoral: {
            "1": "#fcf1f0",
            "2": "#fcecea",
            "3": "#fbddda",
            "4": "#fcc1be",
            "5": "#ff9895",
            "6": "#ff7375",
            "7": "#e9003f",
            "8": "#b2002e",
            "9": "#890021",
            "10": "#6b0318",
            "11": "#5a0514",
            "12": "#530512",
        },
        darkRed: {
            "1": "#fcf1ee",
            "2": "#fcece7",
            "3": "#fbddd4",
            "4": "#fcc2b1",
            "5": "#ff9a7e",
            "6": "#ff5d3b",
            "7": "#ea0101",
            "8": "#b30000",
            "9": "#870a00",
            "10": "#661101",
            "11": "#531303",
            "12": "#4c1304",
        },
        slateGray: {
            "1": "#f3f3f4",
            "2": "#efefef",
            "3": "#e4e4e4",
            "4": "#d0d0d1",
            "5": "#b6b6b7",
            "6": "#969698",
            "7": "#777779",
            "8": "#5a595c",
            "9": "#444345",
            "10": "#343335",
            "11": "#2b2b2d",
            "12": "#131117",
        },
        fushia: { "1": "#CC1480" },
    },
    semantic: {
        brand: {
            primary: "#221c46",
            "primary-dimmed": "#e3e2fa",
            "primary-light": "#b1b0fb",
            secondary: "#00eb5e",
            "secondary-light": "#85fd96",
            "secondary-dimmed": "#c7fcca",
            "secondary-dark": "#012f0d",
            tertiary: "#17ccf9",
            "tertiary-light": "#88ddfb",
            "tertiary-dimmed": "#def3fb",
            "tertiary-dark": "#062c37",
            quaternary: "#ffdc37",
            "quaternary-light": "#fdeec1",
            "quaternary-dimmed": "#fdf3d6",
            "quaternary-dark": "#2f2700",
            quinary: "#ff7375",
            "quinary-light": "#fcc1be",
            "quinary-dimmed": "#fbddda",
            "quinary-dark": "#530512",
        },
        text: {
            primary: "#221c46",
            secondary: "#463f5f",
            tertiary: "#5a5469",
            quaternary: "#908c99",
            inverse: "#ffffff",
            disabled: "#b5b2bc",
            error: "#b30000",
            link: "#1b51dc",
            hover: "#526cf8",
            pressed: "#0f266d",
            highlight: "#CC1480",
            info: "#0f2365",
            success: "#042e20",
            warning: "#874810",
        },
        foreground: {
            primary: "#221c46",
            secondary: "#221c46",
            tertiary: "#221c46",
            quaternary: "#221c46",
            quinary: "#e3e2fa",
            info: "#0f2365",
            success: "#042e20",
            warning: "#3c210a",
            error: "#4c1304",
        },
        icon: {
            primary: "#221c46",
            secondary: "#908c99",
            tertiary: "#5a5469",
            inverse: "#ffffff",
            disabled: "#b5b2bc",
            info: "#1b51dc",
            success: "#006245",
            warning: "#b26019",
            error: "#b30000",
            pressed: "#0f266d",
            highlight: "#CC1480",
        },
        border: {
            primary: "#908c99",
            secondary: "#d1cfd7",
            tertiary: "#f0eef5",
            inverse: "#ffffff",
            disabled: "#b5b2bc",
            error: "#b30000",
            created: "#878dfa",
            inprogress: "#f8a05b",
            delay: "#874810",
            shipped: "#01d253",
        },
        outline: { focus: "#1b51dc", inverse: "#ffffff" },
        surface: {
            "1": "#ffffff",
            "2": "#ffffff",
            "3": "#ffffff",
            "4": "#ffffff",
            "5": "#ffffff",
            "1-hover": "#221c461A",
            skeleton: "#e5e3ea",
            overlay: "#221c46E6",
        },
        background: {
            primary: "#faf8ff",
            disabled: "#efefef",
            info: "#f3f3fc",
            success: "#d7fcea",
            warning: "#fbf2ec",
            error: "#fcf1ee",
            failed: "#ea0101",
            brand1: "#00eb5e",
            brand2: "#17ccf9",
            brand3: "#ffdc37",
            brand4: "#ff7375",
        },
        interactive: { primary: "#1b51dc", secondary: "#1b51dc1A" },
        cta: {
            primary: "#00eb5e",
            primaryHover: "#c7fcca",
            primaryPressed: "#00330e",
            secondary: "#1b51dc",
            secondaryPressed: "#0f266d",
            secondaryHover: "#def3fb",
            secondaryHoverStrong: "#c3ebfb",
            secondaryHoverInverse: "#878dfa",
        },
        illustration: {
            foreground1: "#221c46",
            foreground2: "#ffffff",
            foreground3: "#01ad43",
            foreground4: "#0fa4c9",
            foreground5: "#ad9400",
            foreground6: "#ff7375",
            background1: "#ffffff",
            background2: "#221c46",
            background3: "#dafcdb",
            background4: "#def3fb",
            background5: "#fdf3d6",
            background6: "#fcecea",
            background7: "#00eb5e",
            background8: "#17ccf9",
            background9: "#ffdc37",
            background10: "#ff7375",
            backgroundNeutral: "#e8f6fc",
            foregroundError: "#b30000",
            backgroundError: "#fcf1ee",
            foregroundWarning: "#b26019",
            backgroundWarning: "#fbf2ec",
            foregroundSuccess: "#006245",
            backgroundSuccess: "#d7fcea",
            foregroundInfo: "#1b51dc",
            backgroundInfo: "#f3f3fc",
        },
        tag: {
            defaultEnable: "#e3e2fa",
            defaultHover: "#878dfa",
            validationEnable: "#d7fcea",
            errorEnable: "#fbddd4",
            errorHover: "#ff9a7e",
            validationHover: "#00cf96",
            disabled: "#efefef",
            pressed: "#0f266d",
        },
    },
};
export default colors;
//# sourceMappingURL=colors.js.map